import { useService } from 'react-reservice';

import { appThemeService } from './service';

export const useAppTheme = () => useService(appThemeService, (context) => context);
